export default __webpack_public_path__ + "static/media/cbp_light.ba597123.svg";